const MessageLogin = () => import('@/views/MessageLogin')

export default [
  {
    path: '/messageLogin',
    component: MessageLogin
  }
]
